import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, reset } from 'redux-form';

import NewPeriodHeader from '../../components/bulkPeriodManagement/NewPeriodHeader';
import * as newPeriodActions from '../../actions/newPeriodActions';
import * as reitActions from '../../actions/reitActions';
import * as clientActions from '../../actions/clientActions';
import NewPeriodTable from '../../components/bulkPeriodManagement/NewPeriodTable';

import { store } from '../../store/configureStore';
import * as actions from '../../actions/actionTypes';
import { withRouter } from '../../common/withRouter';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link } from 'react-router';
import * as Constants from '../../constants/other';
/**
 * BulkPeriodManagementContainer component
 * @extends {React.Component}
 */
export class BulkPeriodManagementContainer extends React.Component {
  /**
   * Creates a new BulkPeriodManagementContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);

    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.setGridColumnState = this.setGridColumnState.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.initiateRollForwardReitsProcess =
      this.initiateRollForwardReitsProcess.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.state = {
      gridCurrentState: [],
      gridColumnState: [],
      bulkRollForwardData: [],
      enableSubmit: false,
      bulkProcessActionId: 8 /*Default for Roll Forward*/,
      isAudit: false,
      mostSuitableReportPeriods: [],
    };
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    // Fetch Reits for Bulk Roll Forward
    this.getRollForwardGridData();
    this.getClientData();
  }

  /**
   * Invoked when a new props is recived
   * @returns {undefined}
   */

  componentDidUpdate(prevProps) {
    // Reset grid data based on roll forward type selection
    if (
      JSON.stringify(this.props.bulkRollForwardFormValues) !==
      JSON.stringify(prevProps.bulkRollForwardFormValues)
    ) {
      if (
        this.props.bulkRollForwardFormValues?.quarterSelection !==
          prevProps.bulkRollForwardFormValues?.quarterSelection &&
        this.props.bulkRollForwardFormValues?.quarterSelection !== undefined
      ) {
        const quarter = this.props.bulkRollForwardFormValues?.quarterSelection
          .split(' ')[0]
          .replace('Q', '');
        const year =
          this.props.bulkRollForwardFormValues?.quarterSelection.split(' ')[1];
        this.props.newPeriodActions
          .fetchMostSuitableReportPeriod(this.props.clientId, quarter, year)
          .then((response) => {
            if (response && response.length > 0) {
              this.setState({ mostSuitableReportPeriods: response });
              this.handleRollForwardTypeChange(response);
            }
          });
      } else {
        this.handleRollForwardTypeChange(this.state.mostSuitableReportPeriods);
      }
    }

    // Reset grid data when a data refresh comes in
    if (
      prevProps.bulkRollForwardData &&
      this.props.bulkRollForwardData !== prevProps.bulkRollForwardData
    ) {
      this.handleDataRefresh();
    }
  }

  handleRollForwardTypeChange(mostSuitableReportPeriods) {
    const { bulkRollForwardFormValues } = this.props;

    if (
      bulkRollForwardFormValues &&
      bulkRollForwardFormValues.rollForwardToSelectionType
    ) {
      if (
        bulkRollForwardFormValues.rollForwardToSelectionType ===
        'nextAvailablePeriod'
      ) {
        this.updateBulkRollForwardData((data) => ({
          ...data,
          rollForwardToPeriod: data.nextAvailablePeriod,
          rollForwardFromPeriod: data.currentPeriod,
          reitSelection: this.state.gridCurrentState.find(
            (x) => x.reitid === data.reitid
          )?.reitSelection,
        }));
      } else if (
        bulkRollForwardFormValues.rollForwardToSelectionType === 'customPeriod'
      ) {
        if (bulkRollForwardFormValues?.quarterSelection) {
          this.updateBulkRollForwardData((data) => {
            if (
              bulkRollForwardFormValues?.quarterSelection === data.currentPeriod
            ) {
              return {
                ...data,
                rollForwardToPeriod: Constants.REPORT_PERIOD_EXISTS,
                rollForwardFromPeriod: 'N/A',
                reitSelection: false,
              };
            } else {
              const suitableReportPeriod = this.getFromReportPeriod(
                data.reitid,
                mostSuitableReportPeriods
              );
              if (suitableReportPeriod === Constants.REPORT_PERIOD_EXISTS) {
                return {
                  ...data,
                  rollForwardToPeriod: Constants.REPORT_PERIOD_EXISTS,
                  rollForwardFromPeriod: 'N/A',
                  reitSelection: false,
                };
              }
              return {
                ...data,
                rollForwardToPeriod:
                  bulkRollForwardFormValues?.quarterSelection,
                rollForwardFromPeriod: suitableReportPeriod,
                reitSelection: this.state.gridCurrentState.find(
                  (x) => x.reitid === data.reitid
                )?.reitSelection,
              };
            }
          });
        } else {
          this.updateBulkRollForwardData((data) => ({
            ...data,
            rollForwardToPeriod: null,
            rollForwardFromPeriod: null,
            reitSelection: this.state.gridCurrentState.find(
              (x) => x.reitid === data.reitid
            )?.reitSelection,
          }));
        }
      }
    }
  }

  getFromReportPeriod(reitId, mostSuitableReportPeriods) {
    if (mostSuitableReportPeriods && mostSuitableReportPeriods.length > 0) {
      const found = mostSuitableReportPeriods.find((r) => r.reitid === reitId);
      if (found) {
        if (found.isAlreadyExists) {
          return Constants.REPORT_PERIOD_EXISTS;
        }
        return found.suitableReportPeriodToCopy;
      }
    }
  }

  handleDataRefresh() {
    this.setState(
      {
        bulkRollForwardData: this.props.bulkRollForwardData,
        enableSubmit: false,
      },
      this.resetForm
    );
  }

  updateBulkRollForwardData(updateFn) {
    const updatedBulkRollForwardData = this.state.bulkRollForwardData.map(
      (data) => {
        if (data.isReitActive && data.isReitAvailableForSelection) {
          return updateFn(data);
        } else {
          return data;
        }
      }
    );

    this.setState({ bulkRollForwardData: updatedBulkRollForwardData });
  }

  /**
   * Invoked immediately before unmounting occurs
   * @returns {undefined}
   */
  componentWillUnmount() {
    // On unmount, clear the state to conserve memory
    this.setState({ bulkRollForwardData: [] });

    // Clearing the redux state for bulk roll forward data
    this.props.newPeriodActions.fetchBulkRollForwardData();
  }

  getRollForwardGridData() {
    this.props.newPeriodActions.fetchBulkRollForwardData(this.props.clientId);
  }

  getClientData() {
    this.props.clientActions.loadClient(this.props.clientId).then(() => {
      this.setState({ isAudit: this.props.isAudit });
    });
  }

  /**
   * Set AG-Grid column state
   * @returns {undefined}
   */
  setGridColumnState() {
    var columnState = localStorage.getItem(
      'REITSuiteBulkRollForwardColumnState'
    );
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }

  /**
   * Handle Grid column state chagne
   * @returns {undefined}
   */
  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  handleGridChanges(gridRowData) {
    const rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          reitid: x.reitid,
          isReitActive: x.isReitActive,
          isReitAvailableForSelection: x.isReitAvailableForSelection,
          reitSelection: x.isReitAvailableForSelection
            ? x.reitSelection
            : false,
          reitName: x.reitName,
          currentPeriod: x.currentPeriod,
          rollForwardToPeriod: x.reitSelection
            ? this.getRollForwardToPeriod(x.reitid)
            : null,
          rollForwardStatus: x.rollForwardStatus,
          rollForwardFromPeriod: x.rollForwardFromPeriod,
        };
      });

    this.setState(
      { gridCurrentState: rowData },
      this.checkForSubmitButtonEnablement
    );
  }

  getRollForwardToPeriod(reitId) {
    const [first] = this.state.bulkRollForwardData.filter(
      (r) => r.reitid === reitId
    );
    return first.rollForwardToPeriod;
  }

  checkForSubmitButtonEnablement() {
    if (Array.isArray(this.state.gridCurrentState)) {
      const isAnyReitSelected = this.state.gridCurrentState.some(
        (r) => r.reitSelection
      );
      //const areReitsSlected = this.state.bulkRollForwardData.some(r => r.reitSelection);

      if (
        isAnyReitSelected &&
        this.props.bulkRollForwardFormValues?.rollForwardToSelectionType ===
          'nextAvailablePeriod'
      ) {
        this.setState({ enableSubmit: true });
      } else if (
        isAnyReitSelected &&
        this.props.bulkRollForwardFormValues?.rollForwardToSelectionType ===
          'customPeriod'
      ) {
        if (this.props.bulkRollForwardFormValues?.quarterSelection) {
          this.setState({ enableSubmit: true });
        } else {
          this.setState({ enableSubmit: false });
        }
      } else if (!isAnyReitSelected) {
        this.setState({ enableSubmit: false });
      }
    }
  }

  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }
  initiateRollForwardReitsProcess() {
    const request = {
      clientId: this.props.clientId,
      calendarYear: this.state.selectedCalanderYear,
      quarterDescription: this.state.selectedReportPeriod,
      reitIds: this.getSelectedReits(),
      bulkProcessActionId: this.state.bulkProcessActionId,
      diagnosticMessage: this.state.diagnosticMessage,
      bulkProcessRequestJSON: this.getBulkProcessRequestJSON(),
    };

    const currentGridState = [...this.state.gridCurrentState];
    const currentBulkRollForwardDataState = [...this.state.bulkRollForwardData];

    this.updateGridAndDataStatePostSubmission(request.reitIds);

    this.resetForm();

    this.props.newPeriodActions
      .initiateBulkRollForwardProcess(request, currentBulkRollForwardDataState)
      .then((isErrored) => {
        if (isErrored) {
          this.setState({
            currentGridState: currentGridState,
            bulkRollForwardData: currentBulkRollForwardDataState,
          });
        }
      })
      .catch((isErrored) => {
        if (isErrored) {
          this.setState({
            currentGridState: currentGridState,
            bulkRollForwardData: currentBulkRollForwardDataState,
          });
        }
      });
  }

  updateGridAndDataStatePostSubmission(reitsToBeUpdated) {
    const rowData = this.state.gridCurrentState.map((row) => {
      if (reitsToBeUpdated.find((r) => r === row.reitid)) {
        return {
          ...row,
          isReitAvailableForSelection: false,
          reitSelection: false,
          rollForwardToPeriod: null,
          rollForwardFromPeriod: null,
        };
      } else {
        return {
          ...row,
          rollForwardToPeriod: null,
          rollForwardFromPeriod: null,
        };
      }
    });

    const updatedBulkRollForwardtData = this.state.bulkRollForwardData.map(
      (data) => {
        if (reitsToBeUpdated.find((r) => r === data.reitid)) {
          return {
            ...data,
            isReitAvailableForSelection: false,
            reitSelection: false,
            rollForwardToPeriod: null,
            rollForwardFromPeriod: null,
          };
        } else {
          return {
            ...data,
            rollForwardToPeriod: null,
            rollForwardFromPeriod: null,
          };
        }
      }
    );

    this.props.newPeriodActions.dispatchBulkRollForwardData(
      updatedBulkRollForwardtData,
      actions.LOAD_BULK_ROLL_FORWARD_DATA_REFRESH
    );
    this.setState({ gridCurrentState: rowData });
  }

  getSelectedReits() {
    return this.state.gridCurrentState
      .filter((r) => r.reitSelection)
      .map((r) => r.reitid);
  }

  getBulkProcessRequestJSON() {
    return {
      services: null,
      requestedSignOffStatus: null,
      bulkRollForwardSelections: this.getBulkRollForwardSelections(),
    };
  }

  getBulkRollForwardSelections() {
    const dataSelections = this.state.gridCurrentState
      .filter((r) => r.reitSelection)
      .map((r) => {
        return {
          reitId: r.reitid,
          currentPeriod: r.currentPeriod,
          rollForwardToPeriod: r.rollForwardToPeriod,
          RollForwardFromPeriod: r.rollForwardFromPeriod,
        };
      });

    return dataSelections;
  }

  resetForm() {
    store.dispatch(reset('bulkRollForwardForm'));
  }

  /**
   * Render a React element
   * @returns {Object} A reference to the component
   */
  render() {
    const { bulkRollForwardData } = this.state;
    const noData = !bulkRollForwardData || bulkRollForwardData.length === 0;
    return (
      <>
        <h2 data-testid="pghdrBulkPeriodManagement">Bulk Period Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbNewPeriod"
              className="motif-active"
              onClick={() => this.handleTabClick(1)}
            >
              New Period
            </MotifTabControl>
          </Link>
          {/* Conditional rendering for Services Scope tab */}
          {!this.state.isAudit ? (
            <Link
              to={`/client/${this.props.clientId}/bulkPeriodManagement/servicesScope`}
              tabIndex="-1"
            >
              <MotifTabControl
                role="tab"
                data-testid="tbServicesScope"
                onClick={() => this.handleTabClick(2)}
              >
                Services Scope
              </MotifTabControl>
            </Link>
          ) : (
            <></> // Return an empty fragment instead of null
          )}
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/ownership`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbOwnership%"
              onClick={() => this.handleTabClick(3)}
            >
              Ownership %
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/tenantServicesAmenities`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbTenantServicesAmenities"
              onClick={() => this.handleTabClick(4)}
            >
              Tenant Services / Amenities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/signOff`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbSignOff"
              onClick={() => this.handleTabClick(5)}
            >
              Sign Off
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>
        {noData ? (
          <div className="mt-3">No REITs found for the selected client.</div>
        ) : (
          <>
            <NewPeriodHeader
              enableSubmit={this.state.enableSubmit}
              onSubmit={this.initiateRollForwardReitsProcess}
              isAudit={this.state.isAudit}
              clientId={this.props.clientId}
            />
            <NewPeriodTable
              bulkRollForwardData={this.state.bulkRollForwardData}
              handleGridChanges={this.handleGridChanges}
              gridColumnState={this.state.gridColumnState}
              gridCurrentState={this.state.gridCurrentState}
              handleGridColumnStateChange={this.handleGridColumnStateChange}
            />
          </>
        )}
      </>
    );
  }
}

BulkPeriodManagementContainer.propTypes = {
  clientId: PropTypes.number,
  bulkRollForwardData: PropTypes.array,
  newPeriodActions: PropTypes.object,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  return {
    clientId: Number.parseInt(ownProps.router.params.clientId),
    bulkRollForwardData: state.bulkRollForwardData,
    bulkRollForwardFormValues: getFormValues('bulkRollForwardForm')(state),
    isAudit: state.client.isAudit,
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    newPeriodActions: bindActionCreators(newPeriodActions, dispatch),
    reitActions: bindActionCreators(reitActions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({ form: 'bulkRollForwardForm', enableReinitialize: true })(
      BulkPeriodManagementContainer
    )
  )
);
